"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetFieldsConfig = void 0;
var constants_1 = require("../lib/constants");
function GetFieldsConfig(fields, searchIn) {
    if (searchIn === void 0) { searchIn = constants_1.FIELD_CONFIG; }
    return fields.map(function (field) {
        var fieldConfig = searchIn.find(function (fieldConfig) { return fieldConfig.id === field.id; });
        if (!fieldConfig) {
            throw new Error("Field " + field.id + " not found");
        }
        var body = typeof field.data === 'string'
            ? field.data
            : GetFieldsConfig(field.data, fieldConfig.body);
        return {
            id: fieldConfig.id,
            name: fieldConfig.name,
            description: fieldConfig.description,
            size: field.size,
            hasBody: fieldConfig.hasBody,
            body: body,
            data: field.data
        };
    });
}
exports.GetFieldsConfig = GetFieldsConfig;
